import PlanetJupiter from "@/assets/img/today/moon/planets/planet_jupiter_2x.webp"
import PlanetMars from "@/assets/img/today/moon/planets/planet_mars_2x.webp"
import PlanetMercury from "@/assets/img/today/moon/planets/planet_mercury_2x.webp"
import PlanetMoon from "@/assets/img/today/moon/planets/planet_moon_2x.webp"
import PlanetNeptune from "@/assets/img/today/moon/planets/planet_neptune_2x.webp"
import PlanetPluto from "@/assets/img/today/moon/planets/planet_pluto_2x.webp"
import PlanetSaturn from "@/assets/img/today/moon/planets/planet_saturn_2x.webp"
import PlanetSun from "@/assets/img/today/moon/planets/planet_sun_2x.webp"
import PlanetUranus from "@/assets/img/today/moon/planets/planet_uranus_2x.webp"
import PlanetVenus from "@/assets/img/today/moon/planets/planet_venus_2x.webp"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

/** "Jun 18, 19:09" (with time) or "Jun 18". Replaces date-fns `format`. */
export const formatMoonDate = (iso: string, withTime = true): string => {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  const head = `${MONTHS[date.getMonth()]} ${date.getDate()}`
  if (!withTime) return head
  const pad = (n: number) => n.toString().padStart(2, "0")
  return `${head}, ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const PLANETS: Record<string, string> = {
  Sun: PlanetSun,
  Moon: PlanetMoon,
  Mercury: PlanetMercury,
  Venus: PlanetVenus,
  Mars: PlanetMars,
  Jupiter: PlanetJupiter,
  Saturn: PlanetSaturn,
  Uranus: PlanetUranus,
  Neptune: PlanetNeptune,
  Pluto: PlanetPluto,
}

export const getPlanetImage = (name: string): string | null =>
  PLANETS[name.trim()] ??
  PLANETS[name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()] ??
  null

export interface MoonHeroExtras {
  dayNumber: string
  daySymbolName: string
  lunarSignSymbol: string
  lunarSignName: string
  phasePercent: string
  times: { moonUp: string; moonDown: string; sunUp: string; sunDown: string }
}

export interface LifestyleCard {
  title: string
  description: string
  level: "low" | "medium" | "high"
  action: string
}

export interface DistancePoint {
  dateTime: string
  distanceKm: number
}

export interface DistanceData {
  current: { distanceKm: number; phase: "toApogee" | "toPerigee" }
  points: { perigee: DistancePoint; apogee: DistancePoint; nextPerigee: DistancePoint }
}

/** Static section copy for the Planetary Retrogrades block (the cards are live). */
export const MOON_RETROGRADES = {
  title: "Planetary Retrogrades",
  description:
    "Some planets appear to move backward in the sky — this “retrograde” motion brings a shift in their influence. See which cosmic forces are calling for reflection now.",
}
